<template>
  <v-main class="pa-4" fluid>
    <v-row  >

      <v-snackbar v-model="alerta.activo" multi-line :vertical="true" top right :color="alerta.color" > 
        <strong> {{alerta.texto}} </strong>
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
        </template>
      </v-snackbar>

      <v-col cols="12">
        <v-card  class="shadowCard" >
          <v-card-title primary-title>
            <span class="text-h5 font-weight-bold"> Existencias</span>
            <v-spacer></v-spacer>
            <v-btn color="secondary" dark class="mr-2" @click="initialize()">
              Actualizar
            </v-btn>
            <v-btn class="mr-2" dark color="warning" @click="exportar()"> <v-icon>save_alt</v-icon> </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-col cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  :items="bodegas" 
                  v-model="bodega" 
                  item-text="nombre" 
                  item-value="idbodegas" 
                  label="Bodegas" 
                  dense  
                  hide-details 
                  return-object
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-spacer></v-spacer>
                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    name="name"
                    label="Buscar"
                    id="id"
                    dense
                    hide-details
                    append-icon="mdi-magnify" 
                    v-model="search"
                    clearable
                  ></v-text-field>
                </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :loading="loading"        
                  :headers="headers"
                  :items="productos"
                  :search="search"
                  :height="tamanioPantalla"
                  fixed-header
                  hide-default-footer
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                  dense
                >
                  <template v-slot:no-data>
                    <v-alert type="info" color="primary" outlined :value="true">
                      No hay datos para mostrar
                    </v-alert>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>
        </v-card>
      </v-col>

    </v-row>  
  </v-main>
</template>


<script>
  import {mapActions, mapGetters} from 'vuex'
  import  metodos from '@/mixins/metodos.js';
  import XLSX from 'xlsx'
  
  export default {
    mixins:[metodos],
    data: () => ({
    	
      loading: true,
      longitud:5,
      page: 1,
      pageCount: 0,
      itemsPerPage: 80,
      search:'',
      productos:[],
      headers: [
        { text: 'Codigo', value: 'CODIGO_PRODUCTO' },
        { text: 'Nombre', align: 'left',sortable: false, value: 'NOMBRE_PRODUCTO'},
        { text: 'Existencias', value: 'EXISTENCIAS' },
        { text: 'Ultima Modificacion', value: 'ULTIMA_ACTUALIZACION' },
      ],
      alerta: { activo: false, texto:'', color:'error' },
      bodegas:[],
      bodega:{idbodegas:null, nombre:''},
    }),

    async created(){
      this.initialize();
      this.bodegas = await this.consultar_bodegas();

    },

    methods:{
      ...mapActions('productos',['verExis']),

      initialize(){
        this.loading = true;
        this.productos = [];

        this.$http.get('existencias.list').then(response =>{
        if(response == null){
          this.loading = false
          this.productos = []
        }else{
          this.loading = false
          this.productos = response.body
          this.longitud = this.productos.length
        }
      })
      },

      // EXCEL
      exportar(){
        console.log('productos', this.productos);
        // this.$http.get('existencias.total').then(response =>{
        //   this.exportExcel( response.body )
        // }).catch(error=>{
        //   console.log(error)
        // })
      },

      // s2ab(s) {
      //   var buf = new ArrayBuffer(s.length);
      //   var view = new Uint8Array(buf);
      //   for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      //   return buf;
      // },

      // exportExcel(value){
      //   value.sort((a , b)=>{
      //     if (a.NOMBRE_PRODUCTO > b.NOMBRE_PRODUCTO) {
      //       return 1;
      //     }
      //     if (a.NOMBRE_PRODUCTO < b.NOMBRE_PRODUCTO) {
      //       return -1;
      //     }
      //     // a must be equal to b
      //     return 0;
      //   });

      //   let data = XLSX.utils.json_to_sheet(value)
      //   const workbook = XLSX.utils.book_new()
      //   const filename = 'Existencias'
      //   XLSX.utils.book_append_sheet(workbook, data, filename)

      //   var wbout = XLSX.write(workbook, {
      //     bookType: 'xls',
      //     bookSST: false,
      //     type: 'binary'
      //   });

      //   const file = new File([new Blob([this.s2ab(wbout)])], filename + '.xls')
      //   console.log(file)
        
      //   let formData = new FormData();
      //   // //se crea el objeto y se le agrega como un apendice el archivo 
      //   formData.append('file',file);
      //   // /*Initialize the form data*/
      //   // console.log('archivo',archivo)
      //   this.$http.post('pdfs',formData).then(response=> {
      //     // alert(response.body)
      //     window.location = this.$http.options.root + 'pdfs/' + filename + '.xls'
      //   }).catch(error=> {
      //     alert(error.body)
      //     console.log(error);
      //   });

      // },

      edit(item){
        this.verExis(item).then(response=>{
          this.$router.push({name:'verexistencia'})
        })
      }

      
    },

  }
</script>





